import { IBaseAction } from './base.state';
export enum ThemeActionTypes {
  SET_THEME = 'THEME.SET_THEME',
}
export interface IThemeState {
  currentTheme: number;
}
export interface ISetThemeAction extends IBaseAction {
  type: typeof ThemeActionTypes.SET_THEME;
  currentTheme: number;
}

export type TThemeAction = ISetThemeAction;
